import { TranslatedCopy } from "..";

export enum FiltersResponseKey {
  MILEAGE = "mileage",
  YEAR = "year",
  PRICE = "price",
  COLOR_EXTERIOR = "color_exterior",
  COLOR_INTERIOR = "color_interior",
  INVENTORY_TOTAL = "inventory_total",
  MODEL = "model",
  CATEGORY = "category",
  TRANSMISSION = "transmission",
  TRIMLINE = "trimline",
  VEHICLE_TYPES = "vehicle_types",
  IN_STOCK = "in_stock"
};

export interface MinMaxOption {
  min: number;
  max: number;
};

export interface BasicFilterOption {
  label: TranslatedCopy;
  value: string;
  count: number;
};

export interface ColourFilterOption extends BasicFilterOption {
  hex_code: string;
};

export interface ModelFilterOption extends Omit<BasicFilterOption, "count"> {
  vehicle_types: string[];
  previous: boolean;
  image: string;
  background_color: string;
  new: number;
  used: number;
  certified: number;
  demo?: number;
  alt: TranslatedCopy;
};

export interface FiltersResponse {
  [FiltersResponseKey.MILEAGE]: MinMaxOption;
  [FiltersResponseKey.YEAR]: MinMaxOption;
  [FiltersResponseKey.PRICE]: MinMaxOption;
  [FiltersResponseKey.COLOR_EXTERIOR]: ColourFilterOption[];
  [FiltersResponseKey.COLOR_INTERIOR]: ColourFilterOption[];
  [FiltersResponseKey.INVENTORY_TOTAL]: number;
  [FiltersResponseKey.MODEL]: ModelFilterOption[];
  [FiltersResponseKey.CATEGORY]: BasicFilterOption[];
  [FiltersResponseKey.TRANSMISSION]: BasicFilterOption[];
  [FiltersResponseKey.TRIMLINE]: BasicFilterOption[];
  [FiltersResponseKey.VEHICLE_TYPES]: BasicFilterOption[];
  [FiltersResponseKey.IN_STOCK]: BasicFilterOption[];
};
